/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';

@Component({
    selector: 'app-add-pop-up',
    templateUrl: './add-pop-up.component.html',
    styleUrls: ['./add-pop-up.component.scss'],
    standalone: false
})

export class AddPopUpComponent {
  newValueForm: FormGroup;
  title = 'Add';
  fieldLabel= 'New Value';
  buttonLabel = 'Add';
  maxLength: number;

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<AddPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.title || !data.maxLength) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.maxLength = data.maxLength;
      if (data.fieldLabel) {
        this.fieldLabel = data.fieldLabel;
      }
      if (data.buttonLabel) {
        this.buttonLabel = data.buttonLabel;
      }
    }

    this.newValueForm = new FormGroup({
      newValue: new FormControl(this.newValueForm, [Validators.required])
    });
  }

  /**
   * Close popup window.
   */
  onCancel(): void {
    this.dialogRef.close();
  }

  /**
   * Return new value to add it to DB.
   */
  addValue(): void {
    this.dialogRef.close({
      data: {
        newValue: this.newValueForm.controls.newValue.value
      }
    });
  }

}

